import { cn } from "@v2/lib/utils";

export type StatItem = { label: string; value: string | number; hint?: string; tone?: string };

// Riga di numeri del kit: un solo piano, niente griglie di card.
// Nel DOM l'etichetta precede il numero; a schermo il numero sta sopra.
export function StatStrip({ items, className }: { items: StatItem[]; className?: string }) {
  return (
    <dl className={cn("rounded-[20px] bg-card p-5 grid grid-cols-3 lg:grid-cols-6 gap-x-3 gap-y-5", className)}>
      {items.map((item) => (
        <div key={item.label} className="flex flex-col-reverse justify-end min-w-0">
          {item.hint && <p className="text-xs text-[hsl(var(--faint))] truncate">{item.hint}</p>}
          <dt className="text-[13px] leading-tight text-[hsl(var(--faint))]">{item.label}</dt>
          <dd className={cn("eb-num text-[34px] pr-1 truncate", item.tone)}>{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
